/* © CNES */
import { useContext, useMemo } from 'react';
import Floater from 'react-floater';
import {
  filterSections,
  refMissions,
} from '../../../../../assets/config/filters/Referenciel';
import { ConfigContext } from '../../../../../context/ConfigContext';
import { CollectionsForUser } from '../../../../../models/CollectionsForUser';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import {
  StartGuidContent,
  startGuidStyle,
} from '../../../../shared/startGuidContent/StartGuidContent';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 *  Mission Condition will display the filter depending on Mission selection.
 * @param handleChange Function to handle when a mission button is clicked.
 * @returns MissionCondition Element.
 */
export const MissionCondition = ({
  handleChange,
  userCollections,
}: {
  handleChange: (e: any, key: string) => void;
  userCollections: CollectionsForUser;
}) => {
  /**
   * onChange Mission
   * @param value plaform(s)
   */
  const onChangeMission = (value: string | number[]) => {
    handleChange(value, filterSections.mission.param);
  };
  const context = useContext(ConfigContext);
  const optionData = useMemo(() => {
    return refMissions.filter((element) =>
      userCollections?.collections?.some((el: any) =>
        element.key.includes(el.id)
      )
    );
  }, [userCollections?.collections]);
  return (
    <>
      <Floater
        open={context.isGetStarted}
        content={
          <StartGuidContent
            title="Select a Mission"
            body="Display one or more missions"
            icon="satellite.png"
            isMandatory
          />
        }
        placement="right-end"
        styles={{ ...startGuidStyle }}
        target=".missionFilter"
      />
      <div className="missionFilter">
        <CustomAccordion
          title={filterSections.mission.title}
          children={
            <FilterSelectButtons
              name={filterSections.mission.param}
              options={optionData}
              handleChange={onChangeMission}
              defaultAll={false}
            />
          }
        />
      </div>
    </>
  );
};
